function partitionOverridesByActiveStatus(overrides) {
  const splitIndex = overrides.findIndex(
    (override) => !override.attributes.active,
  );

  return splitIndex === -1 ?
      { activeOverrides: overrides, inactiveOverrides: [] }
    : {
        activeOverrides: overrides.slice(0, splitIndex),
        inactiveOverrides: overrides.slice(splitIndex),
      };
}

export function computedAllScopeViewConditions({
  activeVisibleOverridesCount,
  hasNextPageOfCourseOverrides,
  hasSelectedOverridesForRemoval,
  inactiveLoadedOverridesCount,
  inactiveVisibleOverridesCount,
  isLoadingOverrides,
}) {
  const hasActiveVisibleOverrides = activeVisibleOverridesCount > 0;
  const hasInactiveVisibleOverrides = inactiveVisibleOverridesCount > 0;
  const areSomeInactiveOverridesLoaded = inactiveLoadedOverridesCount > 0;
  const hasVisibleOverrides =
    hasActiveVisibleOverrides || hasInactiveVisibleOverrides;

  const isFullyLoaded = !isLoadingOverrides && !hasNextPageOfCourseOverrides;
  const areActiveOverridesFullyLoaded =
    areSomeInactiveOverridesLoaded || !hasNextPageOfCourseOverrides;

  const shouldKeepInactiveVisibleWhilePendingRemoval =
    hasSelectedOverridesForRemoval &&
    areSomeInactiveOverridesLoaded &&
    hasNextPageOfCourseOverrides &&
    isLoadingOverrides;

  const isActiveLoading =
    isLoadingOverrides &&
    (!hasVisibleOverrides ||
      (hasActiveVisibleOverrides &&
        !hasInactiveVisibleOverrides &&
        !shouldKeepInactiveVisibleWhilePendingRemoval));

  const isInactiveLoading =
    isLoadingOverrides &&
    (!hasVisibleOverrides ||
      hasInactiveVisibleOverrides ||
      shouldKeepInactiveVisibleWhilePendingRemoval);

  return {
    isActiveLoading,
    isInactiveLoading,
    shouldRenderActiveNoOverridesLoadedItem:
      areActiveOverridesFullyLoaded &&
      !hasSelectedOverridesForRemoval &&
      !hasActiveVisibleOverrides,
    shouldRenderInactiveNoOverridesLoadedItem:
      isFullyLoaded &&
      !hasSelectedOverridesForRemoval &&
      !hasInactiveVisibleOverrides,
    shouldRenderInactiveOverridesListSection:
      (!hasSelectedOverridesForRemoval && !hasVisibleOverrides) ||
      hasInactiveVisibleOverrides ||
      shouldKeepInactiveVisibleWhilePendingRemoval ||
      !hasNextPageOfCourseOverrides,
  };
}

export function computedFilteredScopeViewConditions({
  hasNextPageOfCourseOverrides,
  hasSelectedOverridesForRemoval,
  isLoadingOverrides,
  visibleOverridesCount,
}) {
  const hasVisibleOverrides = visibleOverridesCount > 0;
  const isFullyLoaded = !isLoadingOverrides && !hasNextPageOfCourseOverrides;

  return {
    shouldRenderNoOverridesLoadedItem:
      isFullyLoaded && !hasSelectedOverridesForRemoval && !hasVisibleOverrides,
  };
}

export function computedScopedOverrideLists({
  overrides,
  selectedRequirementPriorityIds,
}) {
  const {
    activeOverrides: activeLoadedOverrides,
    inactiveOverrides: inactiveLoadedOverrides,
  } = partitionOverridesByActiveStatus(overrides);

  const activeVisibleOverrides = computeVisibleOverrides({
    overrides: activeLoadedOverrides,
    selectedRequirementPriorityIds,
  });

  const inactiveVisibleOverrides = computeVisibleOverrides({
    overrides: inactiveLoadedOverrides,
    selectedRequirementPriorityIds,
  });

  return {
    activeLoadedOverrides,
    inactiveLoadedOverrides,
    activeVisibleOverrides,
    inactiveVisibleOverrides,
  };
}

export function computeVisibleOverrides({
  overrides,
  selectedRequirementPriorityIds,
}) {
  const selectedRequirementPriorityIdSet = new Set(
    selectedRequirementPriorityIds,
  );

  return overrides.filter(
    (override) =>
      !selectedRequirementPriorityIdSet.has(
        override.relationships.personnelCourseConnectionRequirementPriority.data
          ?.id,
      ),
  );
}
